import React from "react";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import { appRoutesObj } from "./app.paths";
import ForgetPasswordPage from "./pages/user/forget-password-page/forget-password-page";
import NotificationPage from "./pages/user/notification-page/notification-page";
import ParentProfilePage from "./pages/user/profile/profile-parent-page";
import RegisterPage from "./pages/user/register-page/register-page";
import ResearchResultsPage from "./pages/user/research-results-page/research-results-page";
import SchoolRegisterPage from "./pages/user/school-register-page/school-register-page";
import SignInPage from "./pages/user/sign-in-page/sign-in-page";
import CreateSchoolProfilePage from "./pages/admin/create-school-profile-page/create-school-profile-page";
import SchoolProfilePage from "./pages/admin/school-profile-page/school-profile";
import PaymentPage from "./pages/user/payment-page/payment-page";

const ExamplePage = React.lazy(() => import("./pages/user/example-page"));
const SchoolDetailsPage = React.lazy(
  () => import("./pages/user/school-details-page/school-details-page")
);
const NotFoundPage = React.lazy(() => import("./pages/404"));

const withSuspense = (WrappedComponent: JSX.Element) => {
  return (
    <Suspense
      fallback={<div className="text-primary-200 pt-10">Loading...</div>}
    >
      {WrappedComponent}
    </Suspense>
  );
};

export function AppRouting() {
  return (
    <Suspense
      fallback={<div className="text-primary-200 pt-10">Loading...</div>}
    >
      <BrowserRouter>
        <Routes>
          <Route
            key="homepage"
            path={appRoutesObj.getBasePath()}
            element={withSuspense(<App />)}
          />
          <Route
            key="signinpage"
            path={appRoutesObj.getSignInPagePath()}
            element={withSuspense(<SignInPage />)}
          />
          <Route
            key="research-results"
            path={appRoutesObj.getResearchResultsPath()}
            element={withSuspense(<ResearchResultsPage />)}
          />
          <Route
            key="schoolDetailsPage"
            path={appRoutesObj.getSchoolDetailsPath()}
            element={withSuspense(<SchoolDetailsPage />)}
          />
          <Route
            key="registerPage"
            path={appRoutesObj.getRegisterPagePath()}
            element={withSuspense(<RegisterPage />)}
          />
          <Route
            key="schoolRegisterPage"
            path={appRoutesObj.getSchoolRegisterPagePath()}
            element={withSuspense(<SchoolRegisterPage />)}
          />
          <Route
            key="forgetPasswordPage"
            path={appRoutesObj.getForgetPasswordPagePath()}
            element={withSuspense(<ForgetPasswordPage />)}
          />
          <Route
            key="notificationPage"
            path={appRoutesObj.getNotificationPagePath()}
            element={withSuspense(<NotificationPage />)}
          />
          <Route
            key="profileParentPage"
            path={appRoutesObj.getParentProfilePath()}
            element={withSuspense(<ParentProfilePage />)}
          />
          <Route
            key="examplePage"
            path={appRoutesObj.getExamplePagePath()}
            element={withSuspense(<ExamplePage />)}
          />
          <Route
            key="notDefined"
            path="*"
            element={withSuspense(<NotFoundPage />)}
          />
          <Route
            key="creat-school-page"
            path={appRoutesObj.getNewSchoolProfilePage()}
            element={withSuspense(<CreateSchoolProfilePage />)}
          />
          <Route
            key="schoolProfile"
            path={appRoutesObj.getSchoolProfilePage()}
            element={withSuspense(<SchoolProfilePage />)}
          />
          <Route
            key="payment"
            path={appRoutesObj.getPaymentPagePath()}
            element={withSuspense(<PaymentPage />)}
          />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
